import { render } from "./AddEmployee.vue?vue&type=template&id=3f5b0071&scoped=true"
import script from "./AddEmployee.vue?vue&type=script&lang=js"
export * from "./AddEmployee.vue?vue&type=script&lang=js"

import "./AddEmployee.vue?vue&type=style&index=0&id=3f5b0071&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5b0071"]])

export default __exports__